import { h } from './dom';

export type ToastKind = 'error' | 'info' | 'success';

export class ToastHost {
  readonly element: HTMLElement;

  constructor() {
    this.element = h('div', { class: 'toast-host', attrs: { role: 'status', 'aria-live': 'polite' } });
  }

  show(message: string, kind: ToastKind = 'info', timeoutMs = kind === 'error' ? 9000 : 4000): void {
    const close = h('button', { type: 'button', class: 'toast-close', title: 'Dismiss' }, '×');
    const toast = h('div', { class: `toast toast-${kind}` }, h('span', { class: 'toast-text' }, message), close);
    const remove = () => {
      toast.classList.add('is-leaving');
      setTimeout(() => toast.remove(), 200);
    };
    close.addEventListener('click', remove);
    this.element.appendChild(toast);
    if (timeoutMs > 0) setTimeout(remove, timeoutMs);
    while (this.element.children.length > 5) this.element.firstElementChild?.remove();
  }
}
